import React from 'react'
import { TRACKERTYPES } from 'utils/constants'

interface IProps {
  tank: any
  main?: boolean
}

const Battery = ({ tank, main }: IProps) => {
  //If tank type is non trackers and lastupdate is not present -  return null
  if (tank.type != undefined && !TRACKERTYPES.includes(tank.type.toString().toLowerCase()) && !tank.info.lastUpdated) {
    return null;
  }
  //If tank type is of tracker and locationRaw is undefined - return null
  if (tank.type != undefined && TRACKERTYPES.includes(tank.type.toString().toLowerCase()) && tank.locationRaw == undefined) {
    return null;
  }
  let icon = ''
  let tooltipMessage = '';
  if (main) {
    let mainBattery = 'green'
    if (tank.info.data!=undefined && tank.info.data.mbat < 3.1) {
      mainBattery = 'amber'

    }
    tooltipMessage = 'Beacon 3.6v battery strength'
    icon = `battery-${mainBattery}.svg`
  } else {
    if (tank.type === 'bulk' || tank.type === 'cryospeed' || tank.type === 'pack' || (tank.dporhe != undefined && tank.dporhe == 'DP' && tank.type === 'gasmatic')) {
      let secondBattery = 'green'
      if (tank.info.data !=undefined && tank.info.data.sbat < 9) {
        secondBattery = 'amber'
      }
      if (tank.type === 'pack') {
        tooltipMessage = 'Pressure Transducer battery strength'
      }
      else {
        tooltipMessage = 'Beacon 12v battery strength'
      }
      icon = `sbattery-${secondBattery}.svg`
    }
  }

  if (!icon) {
    return null
  }

  return <img className="icon" src={`/images/icons/${icon}`} title={tooltipMessage} />
}

export default React.memo(Battery)
